module.exports = __webpack_public_path__ + "img/borac-banja-luka.4d8adbd6.png";